import request from "../request"
//说明书文件列表
function specificationPage(data) {
    return request({
        method: 'post',
        url: '/specification/page',
        data
    })
}
//说明书保存
function specificationSave(data) {
    return request({
        method: 'post',
        url: '/specification/save',
        data
    })
}
//说明书编辑
function specificationUpdate(data) {
    return request({
        method: 'post',
        url: '/specification/update',
        data
    })
}
//说明书删除
function specificationDelete(id) {
    return request({
        method: 'post',
        url: '/specification/delete/' + id,
    })
}


//知识小课堂文件列表
function knowledgeCornerPage(data) {
    return request({
        method: 'post',
        url: '/knowledgeCorner/page',
        data
    })
}
//知识小课堂保存
function knowledgeCornerSave(data) {
    return request({
        method: 'post',
        url: '/knowledgeCorner/save',
        data
    })
}
//知识小课堂编辑
function knowledgeCornerUpdate(data) {
    return request({
        method: 'post',
        url: '/knowledgeCorner/update',
        data
    })
}
//知识小课堂删除
function knowledgeCornerDelete(id) {
    return request({
        method: 'post',
        url: '/knowledgeCorner/delete/' + id,
    })
}

export { knowledgeCornerDelete, knowledgeCornerPage, knowledgeCornerSave, knowledgeCornerUpdate, specificationDelete, specificationPage, specificationSave, specificationUpdate }

